import { useParams } from 'react-router-dom';

import DocumentsList from '@/app/document/List';
import { DOCUMENT_TYPE } from '@/app/document/enums';

import { useDocuments } from '@/data/document';

const Identification = () => {
  const params = useParams();

  const identityDocuments = useDocuments({
    coachId: params.id,
    type: DOCUMENT_TYPE.IDENTIFICATION
  });

  return (
    <>
      <h2 className="text-2xl font-bold mb-8">Identification</h2>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <h4 className="text-md font-md text-muted-foreground mb-1">
            Identity Documents
          </h4>
          <DocumentsList documents={identityDocuments.data} />
        </div>
      </div>
    </>
  );
};

export default Identification;
